import type { AxiosInstance } from "axios";
import { api as legacyApi, createApiFunctions as createLegacyApiFunctions } from "./api";
import { api as coreApi, createApiFunctions as createCoreApiFunctions } from "./coreApi";

createLegacyApiFunctions(site.legacyPageBaseUrl, site.culture.uiLocale);
createCoreApiFunctions(site.coreApiBaseUrl, site.culture.uiLocale);

const addInterceptors = (api: AxiosInstance) => {
  // Interceptor checks for:
  // - 403 response with invalidLoginSession error code in body -> redirect to target URL
  // - 403 response with { "statusCode": 403 } body -> show rate limit error modal
  api.interceptors.response.use(response => response, (error) => {

    // Some errors don't have responses, like CORS errors
    if (error.response && error.response.data && error.response.status === 403) {

      // Check if this is a SystemOne response
      if ("hasErrors" in error.response.data && "errors" in error.response.data) {
        const response = error.response.data as server.dto.ApiResponse;
        if (response.hasErrors) {
          const revokedForCheatingError = response.errors.find(e => e.code === "invalidLoginSession")
          if (revokedForCheatingError) {
            window.location.href = revokedForCheatingError.target;
          }
        }
      }
      // Check if rate limit has been hit
      // Azure returns 403 response with { "statusCode": 403 } body, so we check for that
      else if (error.response.data?.statusCode === 403) {
        window.displayGenericModal("Error", "Maximum allowed number of actions has been exceeded. Try again at later point.", "mini", "red");
      }
    }
    return Promise.reject(error);
  });
}

addInterceptors(legacyApi);
addInterceptors(coreApi);